// بطاقة الحساب في الترويسة — من أنت، وأيّ يوم وساعة يجري عليها عملك.
//
// **بيانات صاحب الجلسة وحده**: تُقرأ من كائن `me` الذي يعيده `/me` للمستخدم الحالي —
// لا نداء جديد، ولا قائمة موظفين تُجلب لاستخراج سطر منها، ولا معرّف داخلي يُعرض.
// وما لا يوجد لا يُخترع: هاتف غير مسجَّل يظهر «—» لا رقمًا مصنوعًا.
//
// **الساعة حيّة بتوقيت القاهرة، بنظام ١٢ ساعة مع AM/PM**: مؤقّت كل ثانية، والقراءة من `serverNow()` — أي ساعة
// **الخادم** مصحَّحةً بانحراف الجهاز عنه (يُقاس من ترويسة `Date` في كل ردّ)، فلا يعرض
// النظام وقتًا يخالف ما يُسجَّل به فعلًا. والتاريخ من نفس القراءة، فينقلب عند منتصف
// الليل بلا تحديث صفحة. والمؤقّت يُنظَّف عند التفكيك.
import { useEffect, useState } from 'react';
import { serverNow, type Me } from '../lib/api.ts';
import { cairoClock, localPhone } from '../lib/format.ts';

/** الساعة والتاريخ بتوقيت القاهرة، يتجدّدان كل ثانية من ساعة الخادم. */
export function useCairoClock(): { date: string; time: string } {
  const [now, setNow] = useState(() => cairoClock(serverNow()));
  useEffect(() => {
    const id = setInterval(() => setNow(cairoClock(serverNow())), 1000);
    return () => clearInterval(id);
  }, []);
  return now;
}

function Line({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex gap-1 leading-snug">
      <dt className="shrink-0 text-ink-500">{label} :</dt>
      <dd className="min-w-0 break-all text-ink-800">{value}</dd>
    </div>
  );
}

export function HeaderIdentity({ me }: { me: Me }) {
  const { date, time } = useCairoClock();

  return (
    <div className="min-w-0">
      {/* الاسم التجاري مكتوبًا بجانب الشعار: مخفيّ عن قارئ الشاشة لأن بديل الصورة يقوله
          أصلًا، فلا يُنطق مرّتين. أما «iConTravel Sales Management» فاسم النظام ويُقرأ. */}
      <p className="text-xl font-bold leading-tight text-brand-700" aria-hidden="true">iConTravel</p>
      <p className="text-base font-semibold leading-tight text-ink-700">iConTravel Sales Management</p>
      <dl className="mt-1 flex flex-wrap gap-x-6 gap-y-0.5 text-xs">
        <div className="min-w-0">
          <Line label="Sales Name" value={me.fullNameAr} />
          <Line label="Phone Number" value={localPhone(me.phone)} />
          <Line label="Email" value={me.email} />
        </div>
        <div className="min-w-0">
          <Line label="Date" value={date} />
          {/* الثواني تتغيّر كل ثانية: `aria-live` مغلق عمدًا حتى لا يُقاطع قارئ الشاشة كل ثانية */}
          <div className="flex gap-1 leading-snug">
            <dt className="shrink-0 text-ink-500">Time :</dt>
            {/* `dir="ltr"`: في سطر عربي تُعيد خوارزمية الاتجاه ترتيب «01:34:18 AM» فتضع
                AM أوّلًا. والوقت وحدةٌ واحدة تُقرأ من اليسار، فيُثبَّت اتجاهها صراحةً. */}
            <dd dir="ltr" className="tabular-nums text-ink-800" data-testid="header-clock">{time}</dd>
          </div>
        </div>
      </dl>
    </div>
  );
}
